import angular from "angular";
import { SelectRecordModalService } from "./service";
import { selectRecordModalComponentOptions } from "./component";
import { vsComponentName, vsServiceName } from "./names";

export const vsModuleName = "selectRecordModalModule";

angular
  .module(vsModuleName, [])
  .service(vsServiceName, SelectRecordModalService)
  .component(vsComponentName, selectRecordModalComponentOptions);
